import { TemplateRepository } from "../domain/TemplateRepository";

interface DeleteTemplateState {
  isDeleting: boolean;
  deleteError: string | null;
}

export class DeleteTemplateCommand {
  constructor(
    private readonly template_repo: TemplateRepository,
    private readonly state: DeleteTemplateState,
  ) {}

  async execute(templateId: number, companyId: number, userId: number): Promise<any> {

    this.state.isDeleting = true;
    this.state.deleteError = null;

    try {
      const result = await this.template_repo.delete(templateId, companyId, userId);
      this.state.isDeleting = false;
      return result;
    } catch (error) {
      this.state.isDeleting = false;
      throw error;
    }
  }
}
